<div class="back-button-container">
  <button mat-icon-button (click)="onBack()">
    <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-circle-arrow-left"></mat-icon>
  </button>
  <p class="small-font">
    <span *ngFor="let previousPage of previousPages; let last = last">
      {{ previousPage | translate }}
      {{ !last ? "/ " : "" }}
    </span>
  </p>
</div>
